export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";